import React, { useState, useEffect } from "react";
import { Link } from "@reach/router";
import { MenuContainer } from "../styled_components/containers";
import MenuItem from "../styled_components/menu-item";
import Bubble from "../styled_components/bubble";
import assignments from "../assets/assignments.png";
import games from "../assets/games.png";
import trophies from "../assets/trophies.png";
import yourEmile from "../assets/your_emile.png";
import ship from "../assets/ship.png";
import download from "../assets/download.png";
import ranks from "../assets/ranks.png";
import clash from "../assets/clash.png";
import war from "../assets/crownicon.png";
import useAuth from "../../auth/hooks/useAuth";
import axios from "axios";
import { Router, navigate } from "@reach/router";
import { Loading } from "../../../globals/components/loading";

import styled from "styled-components";
import ReactTooltip from 'react-tooltip';
import { getThemeProps } from "@material-ui/styles";

function Menu(props) {
    const [selectedItem, setSelectedItem] = useState(window.location.pathname);
    const [assignmentCount, updateAssignmentCount] = useState(0);
    const access_token = useAuth().state.access_token;
    const [importantCounter, setImportantCounter] = useState(-1);

    console.log(props);

    useEffect(() => {
        axios({
            url: `${process.env.REACT_APP_OAUTH_URL}/api/homework`,
            method: "get",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${access_token}`
            }
        }).then((response) => {
            if (response.data !== undefined) {
                updateAssignmentCount(response.data.length);

                var i;
                var incompleteCounter = 0;

                setImportantCounter(0);
                updateAssignmentCount(0);
                var hasClash = false;

                for (i = 0; i < response.data.length; i++) {
                    console.log(response.data[i]);
                    if (response.data[i].important == 1 && response.data[i].submissions.length == 0) {
                        if (response.data[i].assessment_type != "clash")
                        {
                            console.log(response.data[i]);
                            navigate("/assignments");
                            setSelectedItem("/assignments")
                            setImportantCounter(1);
                        }
                        else
                        {
                            if (new Date(response.data[i].starts_at).toDateString() == new Date().toDateString()){
                                hasClash = true;
                            }
                            
                        }
                        

                        console.log(importantCounter);
                    }

                    if (response.data[i].submissions.length == 0 && (response.data[i].highest_level_reached == null ||response.data[i].highest_level_reached == 0)) {
                        incompleteCounter++;
                    }

                }
                if (hasClash){
                    navigate("/clash");
                    setSelectedItem("/clash")
                }
                updateAssignmentCount(incompleteCounter);
            }
        });
    }, []);

    useEffect(() => {
        console.log("change the important counter");
        console.log(props);
        if (props.importantAssignment) {
            setImportantCounter(1);
            updateAssignmentCount(props.incompleteCount);
            console.log("prop count: " + props.incompleteCount);
        }
        else {
            setImportantCounter(0);
            updateAssignmentCount(props.incompleteCount);
            console.log("prop count: " + props.incompleteCount);
        }
    }, []);

    console.log("Important Counter = " + importantCounter);
    console.log("actual count: " + assignmentCount);
    console.log(props.importantAssignment);
    return (
        <div test={props.importantAssignment}>
            {importantCounter === -1 && (
                <Loading
                    background={true}
                    message={"Please wait whilst we load your details..."}
                />
            )} {props.importantAssignment == false ? (

                <MenuContainer>
                    <MenuItem selected={selectedItem === "/games"}>
                        <Link to="/games" onClick={() => setSelectedItem("/games")}>
                            <img src={games} alt="icon" />
                            Games
                </Link>
                    </MenuItem>
                    <MenuItem selected={selectedItem === "/your-emile"}>
                        <Link to="/your-emile" onClick={() => setSelectedItem("/your-emile")}>
                            <img src={yourEmile} alt="icon" />
                            Your Emile
                </Link>
                </MenuItem>
                    <MenuItem selected={selectedItem === "/assignments"}>
                        <Link to="/assignments" onClick={() => setSelectedItem("/assignments")}>
                            {props.incompleteCount > 0 ? <Bubble test={assignmentCount}>{props.incompleteCount}</Bubble> : null}
                            <img src={assignments} alt="icon" />
                            Tasks
                </Link>
                    </MenuItem>
                    <MenuItem selected={selectedItem === "/trophies"}>
                        <Link to="/trophies" onClick={() => setSelectedItem("/trophies")}>
                            <img src={trophies} alt="icon" />
                            Trophies
                </Link>
                    </MenuItem>
                    <MenuItem selected={selectedItem === "/ranks"}>
                            <Link to="/ranks" onClick={() => setSelectedItem("/ranks")}>
                                <img src={ranks} alt="icon" />
                                Rank
                </Link>
                        </MenuItem>

                 <MenuItem selected={selectedItem === "/clash"}>
                        <Link to="/clash" onClick={() => setSelectedItem("/clash")}>
                            {props.clashCount > 0 ? <Bubble test={props.clashCount}> {props.clashCount}</Bubble> : null}
                            <img src={clash} alt="icon" />
                            Battle
                </Link>
                    </MenuItem>

                    <MenuItem selected={selectedItem === "/war"}>
                        <Link to="/war" onClick={() => setSelectedItem("/war")}>
                            <img src={war} alt="icon" />
                            Events
                </Link>
                    </MenuItem>
                    

                    <MenuItem selected={selectedItem === "download"}>
                        <a
                            href={process.env.REACT_APP_DOWNLOAD_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={download} alt="icon" />
                            Download
                </a>
                    </MenuItem>
                </MenuContainer>

            ) : (
                    <MenuContainer>
                        <MenuItem selected={selectedItem === "/games"}>
                            <Link to="/assignments" onClick={() => setSelectedItem("/assignments")} data-tip="You still have an important task to do!">
                                <img src={games} alt="icon" />
                                Games
                </Link>
                        </MenuItem>
                        <MenuItem selected={selectedItem === "/your-emile"}>
                            <Link to="/your-emile" onClick={() => setSelectedItem("/your-emile")}>
                                <img src={yourEmile} alt="icon" />
                                Your Emile
                </Link>
                        </MenuItem>
                        <MenuItem selected={selectedItem === "/assignments"}>
                            <Link to="/assignments" onClick={() => setSelectedItem("/assignments")}>
                                {props.incompleteCount > 0 ? <Bubble>{props.incompleteCount}</Bubble> : null}
                                <img src={assignments} alt="icon" />
                                Tasks
                </Link>
                        </MenuItem>
                        <MenuItem selected={selectedItem === "/trophies"}>
                            <Link to="/trophies" onClick={() => setSelectedItem("/trophies")}>
                                <img src={trophies} alt="icon" />
                                Trophies
                </Link>
                        </MenuItem>

                        <MenuItem selected={selectedItem === "/ranks"}>
                            <Link to="/ranks" onClick={() => setSelectedItem("/ranks")}>
                                <img src={ranks} alt="icon" />
                                Ranks
                </Link>
                        </MenuItem>

                        <MenuItem selected={selectedItem === "/clash"}>
                            <Link to="/clash" onClick={() => setSelectedItem("/clash")}>
                            {props.clashCount > 0 ? <Bubble test={props.clashCount}> {props.clashCount}</Bubble> : null}
                                <img src={clash} alt="icon" />
                                Battle
                </Link>
                        </MenuItem>

                        <MenuItem selected={selectedItem === "/war"}>
                        <Link to="/war" onClick={() => setSelectedItem("/war")}>
                            <img src={war} alt="icon" />
                            Cup
                </Link>
                    </MenuItem>

                        <MenuItem selected={selectedItem === "download"}>
                            <a
                                href={process.env.REACT_APP_DOWNLOAD_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={download} alt="icon" />
                                Download
                            </a>
                        </MenuItem>
                        
                        <Tools />
                    </MenuContainer>

                )}
        </div>
    );
}
/* <MenuItem selected={selectedItem === "/ranks"}>
                            <Link to="/ranks" onClick={() => setSelectedItem("/ranks")}>
                                <img src={ranks} alt="icon" />
                                Ranks
                </Link>
                        </MenuItem>

                                            <MenuItem selected={selectedItem === "/ranks"}>
                            <Link to="/ranks" onClick={() => setSelectedItem("/ranks")}>
                                <img src={ranks} alt="icon" />
                                Ranks
                </Link>
                        </MenuItem>
                        */

export default Menu;

const Tools = styled(ReactTooltip)`
  font-size: 20px !important;
  background-color: #543171FF !important;
`